type BreadProps = {
  [key: string]: string
}

export const BREAD: BreadProps = {
  intj: 'scone',
  intp: 'cinnamonroll',
  entj: 'financier',
  entp: 'anbutter',
  infj: 'baguette',
  infp: 'castella',
  enfj: 'creampuff',
  enfp: 'croffle',
  istj: 'loafbread',
  isfj: 'macaron',
  estj: 'anpan',
  esfj: 'pretzel',
  istp: 'cheesecake',
  isfp: 'soboro',
  estp: 'chocolatine',
  esfp: 'cupcake'
}

type BreadDesc = {
  [key: string]: string
}

type ResultBreadProps = {
  [key: string]: BreadDesc
}

export const RESULT_BREAD: ResultBreadProps = {
  scone: {
    qoute: '천 리 길도 한 걸음부터!',
    name: '스콘',
    desc: '하루하루 계획을 완벽하게 짜는 것을 좋아하며 돈 관리도 잘하는 빵이에요./혼자 있는걸 진짜 좋아하는 빵이에요. 사회활동을 싫어하지만 단체 활동에서 주도적인 빵의 역할을 자주 맡죠./다른 빵에게 무심하며 다른 빵의 생김새와 이름을 잘 기억하지 못하는 편이에요. 정을 붙이는데 시간이 좀 걸리는 빵이죠./수다 떠는 걸 좋아하고, 영화나 책을 보면 다각도로 생각하고 해석하려 하는 이성적이면서도 감성적인 빵이에요./감정에 휘둘리는 걸 싫어하고 맺고 끊는 게 확실한 단호한 빵이에요./말보다는 표정으로 욕하는 빵이에요. 표정을 숨기기 어려운 빵이죠./특별하고 특이한 빵인데 또 그런 소리를 다른 빵에게 듣는 건 싫어요.',
    pair: 'croffle,anbutter'
  },
  cinnamonroll: {
    qoute: '이건 좀 아니지 않아?',
    name: '시나몬 롤',
    desc: '자기애 강한 빵으로 자발적 아싸가 되고 싶은 빵이에요./웬만해서는 상처를 받지 않으며 무뚝뚝한 빵이죠./화를 잘 안 내고, "그럴 수 있지" 하고 넘어가는 빵성 좋은 빵!/전화도 잘 안 받고 문자도 한참 뒤에 보는 빵이에요./우정을 소중히 하지만 용건이 있는 일에만 연락하길 바라는 빵이죠./이 빵은 책을 정말 좋아하는데 사놓고 안 읽는 책이 많아요./다른 빵의 행동을 보고 상황에 따라 어떻게 행동할지 배우는 빵이에요./감정에는 공감하지만 표현이 서툴러서 생각만 많은 빵이죠.',
    pair: 'financier,anpan'
  },
  financier: {
    qoute: '성공한 인생을 살고 싶다',
    name: '휘낭시에',
    desc: '선천적 리더인 경우가 많아 학창 시절 한자리 했던 빵이 많아요. 관종끼가 있달까?/끈기, 책임감이 뛰어난 빵으로 맡은 일을 끝까지 밀고 나가요./스스로의 비전이 매우 확고하고 자존감이 높은 빵이에요./개인주의적이라서, 내 일은 내 일, 니 일은 니 일로 선 그을 수 있는 빵이에요./카리스마 넘치는 빵인 것 같지만, 의외로 사석에서는 무장 해제되는 빵이죠./현실적이고 논리적인 편이지만, 혼자 두면 상상력도 풍부한 다양한 모습의 빵이 될 수 있어요./해보지도 않고 못한다고 말하는 건 싫어하는 빵이에요.',
    pair: 'cinnamonroll,castella'
  },
  anbutter: {
    qoute: '내가 옳다는 걸 증명할 거야',
    name: '앙 버터',
    desc: '나랑 의견이 다른 빵이 있다면 설득해야 개운한 빵이에요./주변 환경에 따라 시시각각 맞출 수 있지만, 변덕이 심하고 자기애가 강한 빵이죠./극한의 위기에서 상황 판단이 빠르고 임기응변에 능한 빵이에요./혼자 돌아다니는 것을 좋아하는 마이웨이 경향이 있는 빵이죠. 냉정하고 욕심 있는 빵이에요./직설적이고 솔직한 표현에 거리낌 없는 빵이에요./좋아하는 빵과 싫어하는 빵을 명확히 구분하는 스타일이죠./인생은 한 번뿐! ‘재미있는 일’이 빵 인생의 원동력이라고 생각해요',
    pair: 'scone,baguette'
  },
  baguette: {
    qoute: '고즈넉한 삶이 좋아',
    name: '바게트',
    desc: '도덕적이고 고결한 존재들이에요. 그래서 자신이 어긋나는 걸 못 견뎌요./새로운 일, 새로운 빵 같은 건 그다지 달갑지 않아요./보통은 집에만 박혀있는 집 빵인데, 아예 멀리 나가는 여행은 또 좋아하는 편이에요./이 빵은 생각이 너무 많아요. 그러다 보니까 망상도 자주 해요./낯가림이 정말 심한 편이에요./눈치는 정말 빨라요./친해지고 싶은 빵이 있어도 상대방이 먼저 다가와 주길 바라요./이 빵에게는 혼자만의 시간이 반드시 필요해요./친하고 마음 맞는 빵과 단 둘이 노는 걸 좋아해요. 다 같이 노는 건 지루하고 무의미한 것 같거든요./무슨 말이든 근거가 없는 걸 싫어해서 찌라시 같은 것에는 그다지 관심이 없어요. 만약 이 빵들이 찌라시에 관심이 있어 보인다면, 그저 유행에 눈치 빠르게 대응하는 것 뿐이에요.',
    pair: 'anbutter,croffle'
  },
  castella: {
    qoute: '나는 그 자체로 충분해',
    name: '카스텔라',
    desc: '나만의 신념과 가치관이 있는 빵이에요./감정 기복이 엄청 심해서 멘탈이 약한 빵인데 상대방이 내 편이 되기 전에는 마음을 표현하지 않아요./이상을 추구하지만 잡생각이 많고 게을러요. 게으른 완벽주의자 빵이죠./시작은 열정적이지만 끝은 흐지부지..! 우유부단한 빵이에요./대체적으로 적응력이 좋고 개방적인, 이해심이 많은 빵으로 은근 사람들에게 관심 받고 싶어 하는 빵이에요./비도덕적인 것에 예민하며 다른 빵에게 폐 끼치는 것을 정말 싫어해요./멀티가 안되고 연락을 귀찮아해 안읽씹을 잘하는 빵이에요.',
    pair: 'financier,creampuff'
  },
  creampuff: {
    qoute: '사랑받고 싶어',
    name: '슈크림빵',
    desc: '말로 사람의 마음을 움직일 수 있는, 남들을 이끄는 타고난 기질의 빵이에요./미래와 현실을 동시에 고려하는 넓은 시야를 가지고 있는 빵이죠./매우 시끄럽고 오지랖이 넓으며 핵인싸가 꿈인 빵이에요./단순하고 멘탈이 강한 편이지만 사실 상처를 받으면 크게 받는 빵이죠. (흑)/연애 할 때는 사랑하는 빵에게 푹 빠져 헌신하는 스타일이에요./눈치가 있고 센스까지 있어 의사소통에 능해요! 표현하는 것 까지 엄청난 빵이죠./계획 세우는 것을 좋아하고 계획대로 다른 빵들을 잘 이끌어가요./다른 빵의 성장을 돕고 영향을 미칠 때 보람을 느껴요.',
    pair: 'castella,soboro'
  },
  croffle: {
    qoute: '자, 내 말을 들어봐',
    name: '크로플',
    desc: '긍정적이고 낙천적인 인싸빵이에요./새로운 빵을 만나는 것에 두려움은 없어요. 하지만 의외로 내향적이고 독립적인 빵이에요./일머리는 확실히 있는 빵이에요. 그런데 금세 싫증을 내기도 하고 충동적인 빵이에요. 반복적인 삶은 지겨워요./순간 집중력이 엄청 좋아요. 그래서 벼락치기가 잘 맞는 빵이에요./거짓말을 정말 못해요. 그래서 입에 발린 소리도 잘 못하는 빵이에요./감정 기복이 심한 편이고 표정에 감정이 다 드러나는 편이에요./리액션이 좋고 이야기를 잘 들어주는 편이라서 고민 상담을 하는 빵이 많아요.',
    pair: 'scone,baguette'
  },
  loafbread: {
    qoute: '안정적인 게 최고야',
    name: '식빵',
    desc: '원리원칙을 좋아하는 계획적인 빵이에요. 예고 없이 갑작스러운 변화는 매우 싫어하는 빵이지요./약속 시간을 꼭 지키며 주어진 빵의 업무는 끝까지 해내는 책임감 있는 빵이에요./회의나 조별 과제에서 주제가 다른 길로 새는 걸 정말 싫어해요./빵의 첫인상이 딱딱하고 차갑다는 말을 들을 때가 있으며 생각하는 게 로봇 같은 면이 있어요./다른 빵에게 철벽을 잘 치는 빵이에요./과거 회상을 좋아하는 빵이며, 다른 빵들이 기억하기 힘든 사소한 추억까지 간직하고 있어요./의젓한 성격의 빵으로 장남이나 장녀 같다는 말을 많이 들어요./휴일은 집에서 주로 보내며 정리 정돈을 우선으로 하는 깔끔한 빵이에요.',
    pair: 'cupcake,chocolatine'
  },
  macaron: {
    qoute: '사랑을 주고 싶다',
    name: '마카롱',
    desc: '애인을 사귀면 오래가는 빵이에요./겸손하며 성격이 온화한 편이라서 호불호가 잘 없는 빵이에요./배려의 아이콘으로 공감 능력이 뛰어나며 눈물도 많지만, 남들 앞에서는 울지 않는 빵이에요./아싸 빵들 사이에서는 인싸고, 인싸 빵들 사이에서는 아싸인 빵이에요./어떨 때는 내향적이고 어떨 때는 외향적인 빵이라 자기 스스로도 자기 성격을 모르는 빵이에요./조용하고 안정적인 삶을 추구하는 빵으로 강한 생활력과 계획성을 갖고 있는 빵이죠./남들이 보기엔 거절을 잘 못하는 빵인 것 같지만, 철저한 계산을 통해 본인의 이익도 잘 챙기는 빵이에요./걱정도 많고 정도 많은 마음 여린 빵이에요.',
    pair: 'cupcake,chocolatine'
  },
  anpan: {
    qoute: '어쨌든 내가 이기면 그만이야',
    name: '단팥빵',
    desc: '현실적이고 이성적이며 직설적인 빵이죠. 호불호가 확실해요./애매모호한걸 싫어해서 뭐든 확실하게 딱 떨어지는 것을 좋아하는 빵이에요./일적으로 다른 빵들에게 인정받는 걸 좋아하는 빵이에요. 다른 빵이 일 못하면 그냥 내가 해버리는!/자기애가 대단한 빵으로 다른 빵 말고 나에게 집중하죠./싸우는걸 싫어하는 빵이지만 어쩔 수 없이 싸운다면 지는 게 더 싫어요./면전에서 독설을 할 지언정 뒷담화는 잘 하지 않는 담백한 빵이에요./나만의 시간을 방해받기 싫고 그래서 외로움을 안타는 빵이죠.',
    pair: 'cinnamonroll,soboro'
  },
  pretzel: {
    qoute: '우리 다 같이 친하게 지내자',
    name: '프레츨',
    desc: '타고난 분위기 메이커 빵이에요! 새로운 빵 좋아! 빵이랑 같이 노는 거 좋아!/새로운 빵과는 어색함을 참을 수 없어 먼저 말을 거는 빵이죠./리액션이 좋은 빵이라 다른 빵의 이야기도 잘 들어주고 제일 리액션이 좋아요./다른 빵에게 싫은 소리하는 걸 못해서, 상처받아도 다른 빵을 배려하느라 얘기를 못해요./눈치를 보는 편이며, 어디가서 사회생활 잘하는 빵이라는 얘기를 많이 들어요./누가 내 의견에 반대하는 빵이 있거나 부탁을 거절당하면 쉽게 마상 입는 빵이에요./내 친구빵, 가족빵. 내 빵들을 잘챙겨요.',
    pair: 'soboro,cheesecake'
  },
  cheesecake: {
    qoute: '내 존재 이유는 뭘까?',
    name: '치즈 케이크',
    desc: '생각은 적극적인데 행동은 소극적인 빵이에요./일반적으로 조용한 빵인데 필요에 따라 사교적인 빵으로 변신하죠./낯가림이 심한 편이지만 일단 친해지면 말도 많고 재미있는 빵이에요./고집이 있고 주장이 강해서 충동적으로 행동할 수 있어요./소비성향이 강해서 쓸데없는 소비를 많이 하는 빵이죠. 플렉스하는 빵이랄까?/카톡을 할 땐 안읽씹보다 읽씹을 하는 편이에요./누가 자기 욕을 해도 그다시 신경 쓰지 않죠./손재주가 좋아 디테일한 일을 잘 해내는 능률이 높은 빵이에요.',
    pair: 'pretzel,anpan'
  },
  soboro: {
    qoute: '안온한 삶을 살고 싶다',
    name: '소보로',
    desc: '자연적인 것, 전원적인 것을 좋아하는 빵이에요. 사소한 것들이 귀찮지만, 쳬계적으로 살고 싶은 빵이죠./모든 일들은 미룰 수 있을 만큼 미루곤 해요. 하지만 한번 삘 받으면 제대로 하는 빵이죠./밖에 돌아다니는 게 싫어서 집 빵인 경우가 많아요./다른 빵을 만나면 기가 빨려서 약속 잡는걸 극혐해요./분석이나 판단력은 좋은데 그걸 행동으로 옮기기엔 결정장애가 있는 빵이죠./감정 기복이 심한 편인데 다른 빵들에게 칭찬을 받으면 하루종일 그 생각에 행복해해요./카톡이 오면 뭐라고 말할지 고민하다가 안읽씹하거나 늦게 답장을 하는 빵이에요.',
    pair: 'creampuff,anpan'
  },
  chocolatine: {
    qoute: '솔직히 인생 뭐 있어?',
    name: '뺑 오 쇼콜라',
    desc: '뒤끝 1도 없는 쿨한 성격으로 개방적인 빵이에요./스트레스를 잘 안 받는 빵이죠. 남 눈치 보지 않고 내가 하고 싶은걸 하는 빵!/환불을 받을 일이나 컴플레인을 넣을 일이 있다면 같이 가면 도움이 될 빵이에요./주변에 일어나는 일에 관심이 많고 눈치가 진짜 빠른 빵이에요./리더십이 있는 편이라 다른 빵 모임이나 활동에서 분위기를 주도하는 멋진 빵이에요./스릴을 좋아해 경쟁이나 내기, 즉흥적인 것을 좋아하는 빵이에요./다른 빵을 만나는 건 좋은데 게을러서 나가기가 힘들어요.',
    pair: 'loafbread,macaron'
  },
  cupcake: {
    qoute: '재미있게 살고 싶다',
    name: '컵케이크',
    desc: '집에 있는 것보다 밖에서 다른 빵을 만나며 힘을 얻는 빵이에요./서프라이즈, 깜짝파티를 좋아하고 새로운 다른 빵과 사교성도 장난 아니죠./성격이 급하고 건망증이 심한데 고집은 또 엄청 센 빵이에요./잘 먹고, 잘 자면 된다고 생각하는, 단순한 생각이 최고인 빵!/ 좋은 게 좋은 거니까 아무리 걱정되는 일이 있어도 조금 고민하다 잠들어버려요./다른 빵들이랑 어울릴 수 없게 되는 게 제일 무서운 빵! 나랑 놀아줘!/쿠크다스 멘탈을 가지고 있어요. 싸우기 보다는 평화를 좋아하는 평화주의자 빵이에요./혼자 있으면 지루해서 뭔가 계속하고 있는 빵이에요.',
    pair: 'loafbread,macaron'
  }
}
